// Copyright (c) 2019 Deere & Company

import IncentiveClaim from '@deere/cps-it.warranty-model-factory/lib/claim-incentive';

export const getUpdatedIncentiveClaim = (currentClaim, selectedAction) => IncentiveClaim.update(currentClaim, {
    selectedAction: {
        $set: selectedAction
    }
});



// WEBPACK FOOTER //
// ./src/claim/incentive/services/update-incentive-claim.js